<div [style.height]="'calc( 100vh - '+ heightFooter + '' + heightHeader +'px ) '" >
  <iframe title="" #iframe id="ngIframe" class="iframe-legado" appIframeTrackerDirective ></iframe>
</div>
